import { render, staticRenderFns } from "./TransactionAnticipation.vue?vue&type=template&id=c2c228da"
import script from "./TransactionAnticipation.vue?vue&type=script&lang=js"
export * from "./TransactionAnticipation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports